import AppSettingsService from '@/api/AppSettingsService/AppSettingsService'
import { readonly, ref } from 'vue'

const rules = ref()
const personalDataProcessing = ref()
const policy = ref()
const mailingInfo = ref()

export const useRules = () => {
  const getFileLinks = async () => {
    const [[, responseRules], [, responsePersonalDataProcessing], [, responsePolicy], [, responseMailingInfo]] =
      await Promise.all([
        AppSettingsService.getProgramRules(),
        AppSettingsService.getPersonalDataProcessing(),
        AppSettingsService.getPolicy(),
        AppSettingsService.getMailingInfo(),
      ])

    rules.value = responseRules?.data.data.file

    personalDataProcessing.value = responsePersonalDataProcessing?.data.data.file

    policy.value = responsePolicy?.data.data.file

    mailingInfo.value = responseMailingInfo?.data.data.file
  }

  return {
    rules: readonly(rules),
    personalDataProcessing: readonly(personalDataProcessing),
    policy: readonly(policy),
    mailingInfo: readonly(mailingInfo),
    getFileLinks,
  }
}
